module.exports = __webpack_public_path__ + "img/wallet2.80c09af2.svg";